import Vue from 'vue'
import { urlTemplate } from '@/utils/Url'
import { EShopConfig, SurveyFieldMap } from 'proto/eshop/Basket_pb'

declare const eshopConfig: EShopConfig.AsObject

interface IConfig extends EShopConfig.AsObject {
	apiHost: string
}

const _config: IConfig = {
	apiHost: window.location.origin,

	...eshopConfig,
}

const config = Vue.observable({
	..._config,
	basketLink: urlTemplate(_config.basketLink)(_config),
	apiUrl: urlTemplate('{apiHost}/{apiUrl}')(_config),

	get isDebug() {
		return Boolean((<any>window).__basketDebug) || process.env.DEBUG
	},

	get surveyEnabled() {
		return _config.surveyFieldsEnabledList.length >= 0
	},

	sfEnabled(field: SurveyFieldMap[keyof SurveyFieldMap]) {
		return this.surveyFieldsEnabledList.length === 0 || this.surveyFieldsEnabledList.indexOf(field) !== -1
	},
})
export default config

console.info('Current app configuration:', config) // eslint-disable-line
